<template>
    <div>
        <!-- <div v-if="Names == ''">
                                        <Mainlayout></Mainlayout>
                                    </div>
                                    <div v-else>
                                        <MainlayoutLogin></MainlayoutLogin>
                                    </div> -->
        <Mainlayout></Mainlayout>
        <CCol sm="12" style="background-size: cover;background:#26224E" :style="{ backgroundImage: `url(${backgroundUrlBox})` }">
            <br /> <br />
            <CRow class="p-2">
                <CCol sm="12">
                    <CContainer class="mt-5 mb-5">
                        <div class="text-center m-3">
                            <p class="custom-64px-700 text-white mt-4">Our Latest Articles</p>
                            <p class="custom-18px-400 font-color-D2D6DB">Stay up to date with our latest articles, featuring insights, tips, and updates on a variety of topics. Explore fresh content designed to keep you informed and inspired.</p>
                        </div>
                    </CContainer>
                </CCol>
    
            </CRow>
            <br /> <br />
        </CCol>
    
        <CCol sm="12">
            <CContainer class="mt-5 mb-5">
                <CRow>
                    <CCol sm="6">
                        <img src="../assets/img/all/blog1.png" style="max-width:100%" />
                        <CRow class="mt-2">
                            <CCol sm="6">
                                <label class="custom-18px-400 font-color-17171B text-left">Created By Admin</label>
                            </CCol>
                            <CCol sm="6">
                                <div class="text-right">
                                    <label class="custom-18px-400 text-right">5 Jan 2025</label>
                                </div>
                            </CCol>
                            <CCol sm="12">
                                <p class="custom-24px-500">
                                    Bagaimana AI Membantu Mempercepat Proses Pelaporan
                                </p>
                            </CCol>
                        </CRow>
                    </CCol>
                    <CCol sm="6">
                        <CRow>
                            <CCol sm="4">
                                <img src="../assets/img/all/blog2.png" style="max-width:100%" />
                            </CCol>
                            <CCol sm="8">
                                <CRow>
                                    <CCol sm="7">
                                        <label class="custom-18px-400 font-color-17171B text-left">Created By Admin</label>
                                    </CCol>
                                    <CCol sm="5">
                                        <div class="text-right">
                                            <label class="custom-18px-400 text-right">5 Jan 2025</label>
                                        </div>
                                    </CCol>
                                </CRow>
                                <p class="custom-24px-500">
                                    5 Tips untuk Melaporkan Jenayah dengan Selamat dan Berkesan
                                </p>
                            </CCol>
                        </CRow>
    
                        <CRow>
                            <CCol sm="4">
                                <img src="../assets/img/all/blog3.png" style="max-width:100%" />
                            </CCol>
                            <CCol sm="8">
                                <CRow>
                                    <CCol sm="7">
                                        <label class="custom-18px-400 font-color-17171B text-left">Created By Admin</label>
                                    </CCol>
                                    <CCol sm="5">
                                        <div class="text-right">
                                            <label class="custom-18px-400 text-right">5 Jan 2025</label>
                                        </div>
                                    </CCol>
                                </CRow>
                                <p class="custom-24px-500">
                                    Mengapa Anonimitas Penting dalam Pelaporan Jenayah?
                                </p>
                            </CCol>
                        </CRow>
    
                        <CRow>
                            <CCol sm="4">
                                <img src="../assets/img/all/blog4.png" style="max-width:100%" />
                            </CCol>
                            <CCol sm="8">
                                <CRow>
                                    <CCol sm="7">
                                        <label class="custom-18px-400 font-color-17171B text-left">Created By Admin</label>
                                    </CCol>
                                    <CCol sm="5">
                                        <div class="text-right">
                                            <label class="custom-18px-400 text-right">5 Jan 2025</label>
                                        </div>
                                    </CCol>
                                </CRow>
                                <p class="custom-24px-500">
                                    Bagaimana AI Mengesan Corak Jenayah di Kawasan Anda?
                                </p>
                            </CCol>
                        </CRow>
                    </CCol>
                </CRow>
            </CContainer>
        </CCol>
    
        <CCol sm="12">
            <CContainer>
                <CRow>
                    <CCol sm="4">
                        <img src="../assets/img/all/blog5.png" style="max-width:100%" />
                        <CRow class="mt-2">
                            <CCol sm="7">
                                <label class="custom-18px-400 font-color-17171B text-left">Created By Admin</label>
                            </CCol>
                            <CCol sm="5">
                                <div class="text-right">
                                    <label class="custom-18px-400 text-right">5 Jan 2025</label>
                                </div>
                            </CCol>
                            <CCol sm="12">
                                <p class="custom-24px-500">
                                    The Role of AI in Handling Cybercrime Cases
                                </p>
                            </CCol>
                        </CRow>
                    </CCol>
                    <CCol sm="4">
                        <img src="../assets/img/all/blog6.png" style="max-width:100%" />
                        <CRow class="mt-2">
                            <CCol sm="7">
                                <label class="custom-18px-400 font-color-17171B text-left">Created By Admin</label>
                            </CCol>
                            <CCol sm="5">
                                <div class="text-right">
                                    <label class="custom-18px-400 text-right">5 Jan 2025</label>
                                </div>
                            </CCol>
                            <CCol sm="12">
                                <p class="custom-24px-500">
                                    How AI Helps Crime Victims Achieve Justice?
                                </p>
                            </CCol>
                        </CRow>
                    </CCol>
                    <CCol sm="4">
                        <img src="../assets/img/all/blog7.png" style="max-width:100%" />
                        <CRow class="mt-2">
                            <CCol sm="7">
                                <label class="custom-18px-400 font-color-17171B text-left">Created By Admin</label>
                            </CCol>
                            <CCol sm="5">
                                <div class="text-right">
                                    <label class="custom-18px-400 text-right">5 Jan 2025</label>
                                </div>
                            </CCol>
                            <CCol sm="12">
                                <p class="custom-24px-500">
                                    How AI Helps Reduce Bias in Law Enforcement
                                </p>
                            </CCol>
                        </CRow>
                    </CCol>

                    <CCol sm="4">
                        <img src="../assets/img/all/blog8.png" style="max-width:100%" />
                        <CRow class="mt-2">
                            <CCol sm="7">
                                <label class="custom-18px-400 font-color-17171B text-left">Created By Admin</label>
                            </CCol>
                            <CCol sm="5">
                                <div class="text-right">
                                    <label class="custom-18px-400 text-right">5 Jan 2025</label>
                                </div>
                            </CCol>
                            <CCol sm="12">
                                <p class="custom-24px-500">
                                    The Role of AI in Tracking Digital Evidence
                                </p>
                            </CCol>
                        </CRow>
                    </CCol>
                    <CCol sm="4">
                        <img src="../assets/img/all/blog9.png" style="max-width:100%" />
                        <CRow class="mt-2">
                            <CCol sm="7">
                                <label class="custom-18px-400 font-color-17171B text-left">Created By Admin</label>
                            </CCol>
                            <CCol sm="5">
                                <div class="text-right">
                                    <label class="custom-18px-400 text-right">5 Jan 2025</label>
                                </div>
                            </CCol>
                            <CCol sm="12">
                                <p class="custom-24px-500">
                                    How AI Helps Communities Report Crimes Through Chat...
                                </p>
                            </CCol>
                        </CRow>
                    </CCol>
                    <CCol sm="4">
                        <img src="../assets/img/all/blog10.png" style="max-width:100%" />
                        <CRow class="mt-2">
                            <CCol sm="7">
                                <label class="custom-18px-400 font-color-17171B text-left">Created By Admin</label>
                            </CCol>
                            <CCol sm="5">
                                <div class="text-right">
                                    <label class="custom-18px-400 text-right">5 Jan 2025</label>
                                </div>
                            </CCol>
                            <CCol sm="12">
                                <p class="custom-24px-500">
                                    AI and Crime Prevention in Public Transportation
                                </p>
                            </CCol>
                        </CRow>
                    </CCol>
                </CRow>
            </CContainer>
        </CCol>
    
    
    
    
    
        <Footerlayout></Footerlayout>
    
    </div>
</template>

<script>
import Vue from "vue";

import AOS from "aos";
import "aos/dist/aos.css";
import { Carousel3d, Slide } from "vue-carousel-3d";
Vue.use(Carousel3d);
import backgroundUrl from "../assets/img/bgPurpleYellow.png";
import backgroundUrlBox from "../assets/img/all/bg-box.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundGenie from "../assets/img/bggenie.png";
import backgroundUrNoArrow from "../assets/img/bgline.png";

import Mainlayout from "../containers/AllHeader.vue";
import MainlayoutLogin from "../containers/LoginHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import ToggleCard from '../components/Toggle.vue';
import { CCarousel, CCarouselItem } from '@coreui/vue';

Vue.use(require("vue-moment"));
Vue.use(require("moment"));
var moment = require("moment");

export default {
    name: "Login",
    components: {
        Mainlayout,
        MainlayoutLogin,
        Footerlayout,
        ToggleCard,
        Carousel3d,
        Slide,
        CCarousel,
        CCarouselItem,
    },

    data() {
        return {
            backgroundUrl,
            backgroundUrl1,
            backgroundUrNoArrow,
            backgroundUrlBox,

            backgroundGenie,
            isActive: false,
            blog: [],
            searchQuery: ''


        };
    },

    created() {
        AOS.init();
    },
    mounted() {
        this.getListBlog();
    },
    computed: {
        filteredLists() {
            const query = (this.searchQuery || '').toLowerCase().trim(); // Ensure searchQuery is a string

            const filtered = this.blog.filter(item => {
                const job = item.Title || ''; // Ensure item.job is a string
                const matchesQuery = query ? job.toLowerCase().includes(query) : true;

                return matchesQuery;
            });

            return filtered;
        },
    },
    methods: {
        toggle() {
            this.isActive = !this.isActive;
        },
        GotoHowItWork() {
            this.$router.push("HowItWork");
        },
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, { withCredentials: true });
                if (response.status === 200 && response.data) {
                    this.user = response.data;
                    this.Names = this.user.name;
                } else {
                    this.$router.push("Blog");
                    console.error("User info retrieval failed:", response.data.detail);
                }
            } catch (error) {
                this.$router.push("Blog");
                console.error("Error fetching user info:", error);
            }
        },
        truncateText(text) {
            const maxLength = 100;
            if (text.length > maxLength) {
                return text.substring(0, maxLength) + '...';
            }
            return text;
        },
        async getListBlog() {
            try {
                this.Busy = true;
                const response = await this.$API.get(this.$ListPublishBlog, {
                    withCredentials: true
                });
                if (response.status === 200) {
                    this.Busy = false;
                    this.blog = response.data;
                } else {
                    // Handle non-200 status code
                }
            } catch (error) {
                // Handle the error here
            }
        },
        OpenPreview(id) {
            this.$router.push("PreviewBlog?id=" + id);
        }
    },

};
</script>

<style scoped>
@import url('https://fonts.cdnfonts.com/css/general-sans');
body {
    top: 0 !important;
    /* font-family: 'General Sans', sans-serif; */
    font-family: 'Montserrat';
}

.truncate {
    font-size: 18px;
    font-weight: 500;
    white-space: nowrap;
    /* Prevents text from wrapping */
}
</style>